import React from "react";

// Unexpected Floating Objects — small absolute SVG glyphs that float outside the grid
export const Asterisk = ({ className = "", size = 48, color = "#2A00D9" }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
    <path d="M12 2v20M2 12h20M4.93 4.93l14.14 14.14M19.07 4.93L4.93 19.07" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);

export const MusicNote = ({ className = "", size = 36, color = "#2A00D9" }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
    <path d="M9 18V5l10-2v13" stroke={color} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="7" cy="18" r="2.5" stroke={color} strokeWidth="1.4" />
    <circle cx="17" cy="16" r="2.5" stroke={color} strokeWidth="1.4" />
  </svg>
);

export const Star4 = ({ className = "", size = 28, color = "#2A00D9" }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
    <path d="M12 1c0 6 5 11 11 11-6 0-11 5-11 11 0-6-5-11-11-11 6 0 11-5 11-11Z" fill={color} />
  </svg>
);

export const Quote = ({ className = "", size = 42, color = "#2A00D9" }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
    <path d="M7 7c-2 1-3 3-3 6h3v4H2v-4c0-4 2-7 5-8l0 2Zm10 0c-2 1-3 3-3 6h3v4h-5v-4c0-4 2-7 5-8l0 2Z" fill={color} />
  </svg>
);

export default function UFOLayer() {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
      <Asterisk className="ufo absolute top-[6%] left-[4%] opacity-60 spin-slow" size={42} />
      <MusicNote className="ufo-slow absolute top-[22%] right-[8%] opacity-40" size={30} />
      <Star4 className="ufo absolute bottom-[18%] left-[10%] opacity-50" size={22} color="#1A1A1A" />
      <Quote className="ufo-slow absolute bottom-[8%] right-[14%] opacity-30" size={48} />
    </div>
  );
}
